export default {
  title: "Wallet картасы дизайны",
  emptyState: {
    description: "Бетке жетүү үчүн «Промо» же «Про+» тарифин сатып алуу керек",
    buttonText: "Тарифтерге",
  },
  tradingPoint: "Сатуу пункту",
  actions: {
    resetDesign: "Негизги дизайнга кайтаруу",
    saveChanges: "Өзгөртүүлөрдү сактоо",
  },
  walletCardPreview: {
    clientName: "Кардардын аты",
    balance: "Баланс",
    discount: "Жеңилдик",
  },
  walletCardSettings: {
    colors: {
      title: "Wallet картасынын түстөрү",
      background: "Фондунун түсү",
      text: "Тексттин түсү",
    },
    logo: {
      title: "Заведениенин логотиби",
      noLogo: "Логотип жок",
      hasLogo: "Логотип бар",
      aspectRatio: "Логотиптин катышы — 1:1",
      fileRequirements: "PNG, JPG, JPEG — 1 файл 5 Мб чейин",
    },
    stripe: {
      title: "Фон",
      noStripe: "Фон жок",
      image: "Сүрөт",
      colorFill: "Түс менен толтуруу",
      aspectRatio: "Катыш — 3:1",
      fileRequirements: "PNG, JPG, JPEG — 1 файл 5 Мб чейин",
      color: "Фондун түсү",
    },
  },
};
